import React from 'react';
import './NewApproach.css';

function NewApproach() {
  const approachItems = [
    {
      id: 1,
      title: 'Prevention Over Reaction',
      description: 'Up to 70 percent of cardiac events and cancers stem from preventable causes. We intervene early with precision testing, lifestyle interventions, and continuous monitoring.'
    },
    {
      id: 2,
      title: 'Optimal Health Is a Daily Practice',
      description: 'Our clinicians actively coach you in lifestyle and environmental optimization, turning evidence into outcomes.'
    },
    {
      id: 3,
      title: 'Designed for Longevity',
      description: 'Our mission is simple: keep you healthy, high-performing, and independent for as long as possible.'
    }
  ];

  return (
    <section className="ttc-approach-main-wrapper py-5">
      <div className="container py-lg-4">
        {/* Section Badge & Main Heading */}
        <div className="text-center mb-5">
          <div className="ttc-approach-badge d-inline-flex align-items-center gap-2 mb-3">
            <span className="ttc-approach-badge-dot"></span>
            <span className="ttc-approach-badge-text">A New Approach</span>
          </div>
          <h2 className="ttc-approach-heading">
            It's About Preventing Disease, <br />
            <span className="ttc-approach-heading-italic">Not Just Fighting It.</span>
          </h2>
        </div>

        {/* Content Row: Left Image & Right List */}
        <div className="row align-items-center gy-4">
          {/* Left Creative Image */}
          <div className="col-12 col-lg-6">
            <div className="ttc-approach-image-container">
              <img 
                src="/images/creatives/landing-text-list-1.png" 
                alt="Doctor consulting with family" 
                className="img-fluid rounded-4 shadow-sm w-100 ttc-approach-img"
              />
            </div>
          </div>

          {/* Right Interactive List */}
          <div className="col-12 col-lg-6 ps-lg-5">
            <div className="ttc-approach-list d-flex flex-column gap-4">
              {approachItems.map((item) => (
                <div key={item.id} className="ttc-approach-item d-flex gap-3 p-3 rounded-3">
                  <div className="ttc-approach-icon-wrapper flex-shrink-0">
                    {/* Blue Circle with White Heart Icon */}
                    <svg 
                      width="26" 
                      height="26" 
                      viewBox="0 0 24 24" 
                      fill="none" 
                      xmlns="http://www.w3.org/2000/svg"
                      className="ttc-approach-icon"
                    >
                      <circle cx="12" cy="12" r="12" fill="#258BF5" />
                      <path 
                        d="M12 17.5S6.5 13.8 6.5 9.8a3.3 3.3 0 0 1 5.5-2.4A3.3 3.3 0 0 1 17.5 9.8c0 4-5.5 7.7-5.5 7.7z" 
                        fill="#FFFFFF" 
                      />
                    </svg>
                  </div>
                  <div>
                    <h3 className="ttc-approach-item-title mb-2">{item.title}</h3>
                    <p className="ttc-approach-item-desc mb-0">{item.description}</p>
                  </div>
                </div>
              ))}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}

export default NewApproach;